module.exports = __webpack_public_path__ + "34865f9a580f93573f79dd1205d74998.glb";